import { AdminComponents } from '@invo.space/shared'

export type RoleType = 'admin' | 'owner' | 'manager' | 'employee' | 'accountant'

export const Role = {
  admin: 'admin',
  owner: 'owner',
  manager: 'manager',
  employee: 'employee',
  accountant: 'accountant',
} as const

export const RoleLabels = {
  [Role.admin]: 'Administrátor',
  [Role.owner]: 'Vlastník',
  [Role.manager]: 'Správce',
  [Role.employee]: 'Zaměstnanec',
  [Role.accountant]: 'Účetní',
} as const

export type User = {
  id: string
  email: string
  fullName: string
  roles: RoleType[]
  verified: boolean
}

export type AdminUser = AdminComponents['schemas']['AdminUser']
